// Sidebar entries owned by the Resume module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { resources, scopes } from '@/utils/permission'
import { resumePaths } from './paths'

export const resumeNav = {
    talentPool: {
        title: 'resume:sidebar_title',
        path: resumePaths.talentPoolManager,
        rsname: resources.resume,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
} satisfies Record<string, SidebarType>
